import Input from "Components/Input";
import { SearchButton, SearchWrapper, Title } from "./SearchRow.styled";
import { FC } from "react";
import SearchMessage from "./SearchMessage";

interface Props {
  handleChange: any;
  state: any;
  total: number;
}

const SearchRow: FC<Props> = ({ handleChange, total, state }) => {
  return (
    <>
      <div>
        <SearchWrapper>
          <Input
            handleChange={handleChange}
            value={state.q}
            placeholder="Search..."
            name="q"
          />

          <SearchButton type="submit"> Go</SearchButton>
        </SearchWrapper>
      </div>
      <div style={{ display: "flex" }}>
        <SearchMessage
          total={total}
          results={state.results}
          loading={state.loading}
          searchTerm={state.q}
          searchCatagory={state.searchCatagory}
        />
      </div>
    </>
  );
};

export default SearchRow;
